import { z } from "zod";

export const loginSchema = z.object({
  email: z.email({ message: "Email invalide" }),
  password: z.string().min(1, { message: "Mot de passe requis" }),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
